export type BinListState = {
    binListRootState: BinList[] | [];
    selectedBinItem: BinList;
    selectedBinItemHistory: BinHisoryList[] | [];
    binGroupList:BinGroup[]|[]

};


export interface BinList {
    bin_id: string | null;
    bin_type:string
    value: number | null;
    label: string;
    code: string;
    toilet_number:string
    location_cn: string;
    location_en: string;
    lat: string;
    lon: string;
    email: string;
    contact_person: string;
    district_id: number | null;
    area_id: number | null;
    bin_type_id: number | null;
    contract:string
    contract_id: number | null;
    zone_id:number|null
    zone_name:string
    bin_group_sequence:string|null
    status: number | null;
    remarks: string;
    create_by: number | null;
    create_date: string;
    update_date: string;
}

export interface BinHisoryList {
    bin_history_id: number;
    code: string;
    location_cn: string;
    location_en: string;
    bin_full_name: string;
    lat: string;
    lon: string;
    district_cn: string;
    area_cn: string;
    bin_type: string;
    contract: string;
    remarks: string;
    status: number;
    username: string;
    create_date: string;
    update_date: string;
    bin_group_sequence:string
}

export interface BinGroup {
    bin_group_id:number
    group_name_tc:string
    group_name_en:string
    is_active:number
}



export const binListState: BinListState = {
    binListRootState: [],
    binGroupList:[],
    selectedBinItemHistory: [],

    selectedBinItem: {
        bin_id: null,
        bin_type:"",
        value: null,
        label: "",
        code: "",
        toilet_number:"",
        location_cn: "",
        location_en: "",
        lat: "",
        lon: "",
        email: "",
        contact_person: "",
        district_id: null,
        area_id: null,
        bin_type_id: null,
        bin_group_sequence:null,
        contract_id: null,
        contract:"",
        status: 1,
        remarks: "",
        create_by: null,
        create_date: "",
        update_date: "",
        zone_id:null,
        zone_name:"",
    },
};
